module.exports = __webpack_public_path__ + "img/about_YinLoo.b7135979.png";